import _ from 'lodash';
import moment from 'moment';

export const loadTeamWidgets = teamId => {
    return Promise.all([fetch(`https://ss2.si-ab.com/teams/${teamId}`).then(response => response.json())])
        .then(([team]) => {
            return Promise.all([
                team,

                fetch(`https://ss2.si-ab.com/tournaments/${team.mainTournamentId}`).then(response =>
                    response.json(),
                ),
                fetch(`https://ss2.si-ab.com/teams/${teamId}/members`).then(response => response.json()),
                fetch(`https://ss2.si-ab.com/players/?teamId=${teamId}&ttId=${team.mainTournamentId}`)
                    .then(response => response.json())
                    .then(players => {
                        return _.chain(players)
                            .orderBy(p => -_.get(p, 'stats.assists', 0) - _.get(p, 'stats.goals', 0))
                            .take(5)
                            .value();
                    }),
                fetch(
                    `https://ss2.si-ab.com/events-v2?ttId=${
                        team.mainTournamentId
                    }&teamId=${teamId}&status[]=live&status[]=notstarted&limit=3&sortDirection=asc`,
                ).then(response => response.json()),
                fetch(
                    `https://ss2.si-ab.com/events-v2?ttId=${
                        team.mainTournamentId
                    }&teamId=${teamId}&status=finished&limit=3&sortDirection=desc`,
                ).then(response => response.json()),
            ]);
        })
        .then(([team, tournament, members, topPlayers, nextMatches, lastMatches]) => {
            const data = {
                team,
                tournament,
                members,
                topPlayers,
                nextMatches: nextMatches.events,
                lastMatches: lastMatches.events,
            };

            return {
                data,
                widgets: prepareLeagueWidgets(data),
            };
        });
};

export const prepareLeagueWidgets = data => {
    return [
        // TABLE
        ...announments(data.nextMatches, 'Next matches'),
        ...announments(data.lastMatches, 'Last matches'),
        ...leagueTable(data),
        ...topPlayers(data),
    ];
};

export const announments = (matches, category) => {
    return matches.map(event => ({
        id: 'MatchAnnouncement',
        props: {
            eventId: event.eventId,
        },
        spec: {
            social: true,
            widgetGroup: event.eventId,
        },
        category: [category],
        key: `an-${event.eventId}`,
    }));
};

export const leagueTable = data => {
    const { tournament, team } = data;

    return [
        {
            id: 'TournamentTableSMWidget',
            props: {
                tournamentId: tournament.id,

                seasonId: tournament.currentSeason.id,
                teamId: team.id,
                team1Id: team.id,
                full: true,
            },
            spec: {
                social: true,
                widgetGroup: 'TournamentTableSMWidget',
            },
            category: ['Table'],
            key: `tt-table`,
        },
        {
            id: 'LeagueTrackerSMWidget',
            props: {
                tournamentId: tournament.id,
                seasonId: tournament.currentSeason.id,
                teamId: team.id,
                team1Id: team.id,
            },
            spec: {
                social: true,
                widgetGroup: 'LeagueTrackerSMWidget',
            },
            category: ['Table'],
            key: `tt`,
        },
    ];
};

export const topPlayers = data => {
    const { tournament, team } = data;

    return [
        {
            id: 'TeamSeasonTopscorersX3V1',
            props: {
                tournamentId: tournament.id,
                teamId: team.id,
                showTShirt: true,
                showTitle: true,
            },
            spec: {
                social: true,
                widgetGroup: 'TeamSeasonTopscorersX3V1',
            },
            category: ['Top players'],
            key: `tt-table`,
        },
        {
            id: 'TeamSeasonTopscorersX3V2',
            props: {
                tournamentId: tournament.id,
                teamId: team.id,
                showTShirt: true,
                showTitle: true,
            },
            spec: {
                social: true,
                widgetGroup: 'TeamSeasonTopscorersX3V2',
            },
            category: ['Top players'],
            key: `tt-table-x2`,
        },
    ];
};



/** WEBPACK FOOTER **
 ** ../src/dash/front/widget-picker/loaders/team.js
 **/